import Axios from "axios";
import gameCaseConfigs from "../config/game.config.json";

export const api = Axios.create({
  baseURL: process.env.NODE_ENV === "production" ? gameCaseConfigs.gameCaseApiUrl : "//localhost:5686"
});
